// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import React from 'react';
import { HelmetProvider } from '/builds/oscar/oscar-frontend/oscar-auth-frontend/node_modules/.pnpm/@umijs+renderer-react@4.0.71_react-dom@18.1.0_react@18.1.0/node_modules/@umijs/renderer-react';
import { context } from './helmetContext';

export const innerProvider = (container) => {
  return React.createElement(HelmetProvider, { context }, container);
}
